<template>
  <v-scroll-y-reverse-transition>
    <v-card outlined color="sexta" class="mx-auto pt-4" max-width="344" flat elevation="1" shaped>
      <v-row class="d-flex flex-column pa-5">
        <v-img
          class="c-header__logo align-self-center"
          :src="branding.loginLogo"
          contain
          max-height="auto"
          max-width="150"
        ></v-img>
        <h3 class="pa-5 pb-1 primeira--text font-weight-bold text-center">Login de Autenticação</h3>
        <h3 class="pt-0 primeira--text font-weight-black text-center">Sistema Controle de Pregão</h3>
        <v-col class="my-0 mt-4">
          <v-text-field
            dense
            outlined
            color="segunda"
            v-model="userAutenticar.email"
            type="email"
            name="email"
            append-icon="email"
            :rulesAutenticar="[rulesAutenticar.required, rulesAutenticar.email]"
            label="E-mail"
            :class="{autenticadoAtivo: isAutenticadoSisPregao}"
          ></v-text-field>
        </v-col>

        <v-col class="mt-n5">
          <v-text-field
            outlined
            dense
            color="segunda"
            :append-icon="iconeLoginTrocar ? 'mdi-eye' : 'mdi-eye-off'"
            :rulesAutenticar="[rulesAutenticar.required, rulesAutenticar.min]"
            :type="iconeLoginTrocar ? 'text' : 'password'"
            name="password"
            label="Senha"
            class="input-group--focused"
            :class="{autenticadoAtivo: isAutenticadoSisPregao}"
            @click:append="iconeLoginTrocar = !iconeLoginTrocar"
            v-on:keyup.enter="loginAutenticar"
            v-model="userAutenticar.password"
          ></v-text-field>
        </v-col>

        <v-col class="d-flex justify-space-between mt-n5 align-center">
          <v-switch
            v-if="isAutenticadoSisPregao"
            class="c-switch__autenticado"
            color="green"
            label="AUTENTICADO"
            :disabled="boardEditing.state.busy"
            @change="alterarAutenticacao"
            v-model="isAutenticadoSisPregao"
          ></v-switch>
          <v-switch
            v-else
            disabled
            class="c-switch__autenticado"
            color="green"
            label="AUTENTICADO"
            v-model="isAutenticadoSisPregao"
          ></v-switch>

          <v-btn
            :color="branding.primaryColor"
            class="white--text"
            :class="{autenticadoAtivo: isAutenticadoSisPregao}"
            :disabled="boardEditing.state.busy || !boardEditing.state.active"
            :loading="boardEditing.state.busy"
            @click="loginAutenticar"
            v-on:dblclick.prevent
          >AUTENTICAR-SE</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-scroll-y-reverse-transition>
</template>

<script>
import axios from "axios";
import { showError, rutPregao } from "@/global";
import branding from "@/config/branding";
export default {
  name: "autenticaPregao",
  inject: ["boardEditing"],
  props: {
    dadosIntegracao: Object
  },
  data: function() {
    return {
      branding,
      isAutenticadoSisPregao: false,
      userAutenticar: {},
      iconeLoginTrocar: false,
      rulesAutenticar: {
        required: value => !!value || "Campo obrigatório.",
        min: v => {
          if (v == undefined) {
            return "Digite uma senha";
          } else {
            return v.length >= 8 || "Min de 8 caracteres";
          }
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Email inválido.";
        }
      }
    };
  },
  methods: {
    enviarAutenticacao(dataAutenticao) {
      this.$emit("getAutenSistPregao", dataAutenticao);
    },
    alterarAutenticacao(value) {
      this.enviarAutenticacao({ ...this.dadosIntegracao.sistemPregao, ativa: value });
    },
    async loginAutenticar() {
      if (!this.boardEditing.state.active || this.boardEditing.state.busy) return;
      const credentials = { ...this.userAutenticar };
      try {
        const { data } = await this.boardEditing.run(() => axios.post(`${rutPregao}/signin`, credentials));
        this.enviarAutenticacao({ ativa: true, acesso: { data, rutPregao: "__controlePregao_user" } });
        this.isAutenticadoSisPregao = true;
        this.userAutenticar = {};
        this.$toasted.global.defaultSuccess({ msg: "Autenticação concluída. Salve a fase para aplicar." });
      } catch (error) { showError(error); }
    }
  },
  created() {
    this.isAutenticadoSisPregao = this.dadosIntegracao.sistemPregao.ativa;
  }
};
</script>
<style>
.c-switch__autenticado label {
  font-size: 13px !important;
  font-weight: 700;
}
.c-gestor-projeto-login .c-gestor-projeto-login-titulo {
  color: #ffffff;
  font-weight: 500;
}
.autenticadoAtivo {
    opacity: 0.5;
    pointer-events: none;
}
</style>
